import React, { memo } from "react";

import { useTranslation } from "react-i18next";

import { brandGray } from "@waterly/utils-isomorphic";

import { WaterlyIcon } from "../../../../misc/icons";

const waterlyConnectIconSx = { fill: brandGray, color: brandGray, ml: -1, mr: 0.5 };

const WaterlyConnectAdornment = () => {
  const { t } = useTranslation(["common"]);

  return <WaterlyIcon sx={waterlyConnectIconSx} titleAccess={t("common:waterly_connect_value")} />;
};

export default memo(WaterlyConnectAdornment);
